import {get, add, list, update, total, exists, destroy, remove} from 'cart-localstorage'
import {local, session, subscribe} from "brownies";
import axios from 'axios'
import {stringify} from 'qs'
import {CountUp} from "countup.js"

// const FormDataJson = require('form-data-json-convert')

const api = axios.create({
    baseURL: GG.actionUrl,
    headers: {
        'X-CSRF-Token': GG.csrfTokenValue
    },
    transformRequest: [
        function (data) {
            return stringify(data)
        }
    ]
})

let LineItem = Garnish.Base.extend({
    $item: null,

    $extraFieldsContainer: null,
    $extraFieldsWrapper: null,

    $messageInput: null,
    $inHonorInput: null,
    $inMemoryInput: null,

    $addMessageBtn: null,
    $amountInput: null,
    $changeBtn: null,
    $deleteBtn: null,

    id: null,
    title: null,
    favorited: false,
    url: false,
    email: false,
    taxId: false,
    categoryId: false,
    categoryName: false,
    octPartner: false,
    octOrganization: false,

    originalAmount: null,

    obj: null,

    init(el) {
        this.$item = $(el)

        this.$extraFieldsContainer = this.$item.find('.extra-fields-container')
        this.$extraFieldsWrapper = this.$item.find('.field-wrapper')

        this.$messageInput = this.$extraFieldsContainer.find('.message-input')
        this.$inHonorInput = this.$extraFieldsContainer.find('.in-honor-input')
        this.$inMemoryInput = this.$extraFieldsContainer.find('.in-memory-input')

        this.$addMessageBtn = this.$item.find('.add-message')

        this.$amountInput = this.$item.find('.amount-input')
        this.$changeBtn = this.$item.find('.change-amount')
        this.$deleteBtn = this.$item.find('.delete-item')

        this.id = this.$item.data('id')
        this.title = this.$item.data('title')
        // Changing to parseInt
        this.amount = parseInt(this.$amountInput.val())
        // this.amount = parseFloat(this.$amountInput.val())
        this.favorited = this.$item.data('favorited')
        this.url = this.$item.data('url')
        this.email = this.$item.data('email')
        this.taxId = this.$item.data('taxid')
        this.categoryId = this.$item.data('category-id')
        this.categoryName = this.$item.data('category-name')
        this.octPartner = this.$item.data('oct-partner')
        this.octOrganization = this.$item.data('oct-organization')

        this.obj = get(this.id)

        this.addListener(this.$deleteBtn, 'click', this.deleteItem)
        this.originalAmount = parseInt(this.$amountInput.val())
        this.addListener(this.$changeBtn, 'click', this.changeAmount)

        this.addListener(this.$addMessageBtn, 'click', this.addMessage)
        this.addListener(this.$messageInput, 'change', this.addMessageToLineItem)
        this.addListener(this.$inHonorInput, 'change', this.addInHonorToLineItem)
        this.addListener(this.$inMemoryInput, 'change', this.addInMemoryToLineItem)
    },

    addMessage() {
        if (this.$extraFieldsContainer.hasClass('active')) {
            // Hide
            this.$addMessageBtn.attr('aria-expanded', 'false')
            this.$extraFieldsContainer.removeClass('active')
            this.$extraFieldsWrapper.velocity('slideUp')
        } else {
            // Show
            this.$addMessageBtn.attr('aria-expanded', 'true')
            this.$extraFieldsContainer.addClass('active')
            this.$extraFieldsWrapper.velocity('slideDown', {duration: 200})

            setTimeout($.proxy(function () {
                this.$messageInput.focus()
            }, this), 300)
        }
    },

    addMessageToLineItem() {
        this.obj.nonprofit.message = this.$messageInput.val()
        update(this.id, 'nonprofit', this.obj.nonprofit)
    },

    addInHonorToLineItem() {
        this.obj.nonprofit.inHonor = this.$inHonorInput.val()
        update(this.id, 'nonprofit', this.obj.nonprofit)
    },

    addInMemoryToLineItem() {
        this.obj.nonprofit.inMemory = this.$inMemoryInput.val()
        update(this.id, 'nonprofit', this.obj.nonprofit)
    },

    deleteItem() {
        let self = this
        this.$item.velocity('slideUp', {duration: 300})
        toastr.info('Item removed')
        setTimeout(function () {
            self.$item.remove()
            CheckoutPage.removeLineItem(self.id, self.octOrganization)
        }, 300)
    },

    changeAmount() {
        let self = this
        let amount = this.$amountInput.val()
        let floatAmount = parseFloat(this.$amountInput.val())

        let result = (floatAmount - Math.floor(floatAmount)) !== 0;

        if (!amount || amount < 10) {
            toastr.error('Minimum $10 is required')
            Garnish.shake(this.$amountInput);

            setTimeout(function () {
                self.$amountInput.val(self.amount)
            }, 300)
        } else if (result) {
            toastr.error('Positive integers are required')
            this.$amountInput.val(get(this.id).price)
            Garnish.shake(this.$amountInput);
        } else {
            update(this.id, 'price', parseInt(this.$amountInput.val()))
            self.amount = amount
            CheckoutPage.updateCartTotalAmount()
            GG.Cart.updateCartTotalAmount()
            // CheckoutPage.updateOctAmount()
        }
    },

    updateAmountInput() {
        let amount = get(this.id).price
        this.$amountInput.val(amount)
    }
})

GG.CheckoutIndex = Garnish.Base.extend({
    $cartWrapper: null,
    $emptyCartBtn: null,
    $cartItemsContainer: null,
    $cartTotalContainer: null,
    $octMessageContainer: null,
    $loader: null,
    $spinner: null,
    totalCounter: null,

    // Form
    $form: null,
    $formSubmitBtn: null,
    $formMessage: null,
    formChanged: false,
    formValidation: null,
    items: null,
    hasOctPartners: false,
    hasOctOrganizationLineItem: false,
    acceptedOct: false,
    lineItems: [],

    // Form Fields
    $phoneInput: null,
    $zipcodeInput: null,

    userId: null,

    // Stripe
    cardComplete: false,
    expirationComplete: false,
    cvcComplete: false,

    // reCaptcha
    reCaptchaReady: false,
    reCaptchaToken: null,

    _tabId: null,
    _amount: 0,

    init() {
        this.$form = $('#checkout-form')
        this.$formMessage = this.$form.find('.form-messages')
        this.$formSubmitBtn = this.$form.find('#pay-now')
        this.$cartWrapper = $('.cart-wrapper')
        this.$emptyCartBtn = $('.empty-cart')
        this.$cartItemsContainer = $('#cart-items')
        this.$octMessageContainer = $('#oct-container')
        this.$loader = $('.loader')
        this.$spinner = $('.spinner')
        this.$cartTotalContainer = this.$form.find('#cart-total')

        this.$phoneInput = this.$form.find('#phone')
        this.$zipcodeInput = this.$form.find('#zipCode')

        this.userId = this.$form.data('user-id')

        // Prep items
        this.items = list()

        if (this.items.length > 0) {
            this.$loader.removeClass('off')
            this.buildListItemsHtml()
        } else {
            this.$cartWrapper.html('<p class="centered">Cart is empty!</p>').velocity('fadeIn')
        }

        this.checkLocalStorage()

        // Prevent refresh if input exist
        this.addListener(Garnish.$win, 'beforeunload', this.handleBeforeUnload)
        this.addListener(this.$form, 'change', this.handleFormChanged)
        this.addListener(this.$emptyCartBtn, 'click', this.emptyCart)
        // this.addListener(this.$form, 'submit', this.handleFormSubmit)
        this.addListener(this.$form, 'keypress', this.handleFormKeyPress)
        // this.addListener(this.$formSubmitBtn, 'click', this.handleFormSubmitManual)

        // this.initStripe()
        // TEMP: disabled
        this.initRecaptcha()
        this.reCaptchaReady = true

        this.validateForm()
        this.initFormMasks()

        console.log('im here')
    },

    validateForm() {
        this.formValidation = this.$form.validate({
            errorClass: "invalid-feedback",
            validClass: "validated",
            highlight: function (e, i) {
                $(e).addClass("is-invalid")
            },
            unhighlight: function (e, i) {
                $(e).removeClass("is-invalid")
            },
            errorPlacement: function (e, i) {
                i.after(e)
            }
        })

        this.formValidation.settings.rules = this.defineFormValidationRules()
        this.formValidation.settings.messages = this.defineFormValidationMessages()
    },

    defineFormValidationRules() {
        return {
            'donator[firstName]': {
                required: true,
            },
            'donator[lastName]': {
                required: true,
            },
            'donator[email]': {
                required: true,
                email: true,
            },
            'donator[phone]': {
                required: true,
                minlength: 12,
            },
            'address[address1]': {
                required: true,
                minlength: 8,
            },
            'address[city]': {
                required: true,
                minlength: 3
            },
            'address[zipCode]': {
                required: true,
                minlength: 5
            }
        }
    },

    defineFormValidationMessages() {
        return {
            'donator[firstName]': 'First Name is required',
            'donator[lastName]': 'Last Name is required',
            'donator[email]': 'Email is required',
            'donator[phone]': {
                required: 'Phone is required',
                minlength: 'Phone is not valid'
            },
            'address[address1]': {
                required: 'Address is required',
                minlength: 'Address too short',
            },
            'address[zipCode]': {
                required: 'Zip Code is required',
                minlength: 'Zip Code not valid'
            },
            'address[city]': {
                required: 'City is required',
                minlength: 'City too short',
            },
        }
    },

    initFormMasks() {
        this.$phoneInput.mask("000-000-0000", {
            placeholder: "000-000-0000"
        })

        this.$zipcodeInput.mask("00000", {
            placeholder: "00000"
        })
    },

    handleFormChanged(e) {
        this.formChanged = true

        // Check if amounts have changed
        let cartRawAmount = this._getCurrentTabCartAmount()

        if (total() !== cartRawAmount) {
            // Update cart amounts
            destroy()

            $.each(this.$cartItemsContainer.find('.cart-item'), $.proxy(function (i, el) {
                let $element = $(el)
                let data = {
                    id: $element.data('id'),
                    userId: this.userId,
                    price: parseInt($element.find('.amount-input').val()),
                    nonprofit: {
                        id: $element.data('id'),
                        name: $element.data('title'),
                        url: $element.data('url'),
                        email: $element.data('email'),
                        taxId: $element.data('taxid'),
                        categoryId: $element.data('category-id'),
                        categoryName: $element.data('category-name'),
                        octPartner: $element.data('oct-partner'),
                        octOrganization: $element.data('oct-organization'),
                        favorited: $element.data('favorited'),
                    }
                }
                add(data)
            }, this))

            this.updateCartTotalAmount()
            this._updateStripePaymentIntent()
        }
    },

    handleBeforeUnload(e) {
        if (this.formChanged) {
            let message = 'Are you sure you want to refresh?'
            if (e) {
                e.originalEvent.returnValue = message
            } else {
                window.event.returnValue = message
            }

            return message
        }
    },

    initStripe() {
        if (this.items.length > 0) {
            window.stripe = Stripe(GG.Stripe.spk2)

            let elements = stripe.elements()
            let cardStyles = {
                base: {
                    color: '#32325d',
                    fontSmoothing: 'antialiased',
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            }

            let elementClasses = {
                base: 'field-input',
                focus: 'focus',
                empty: 'empty',
                invalid: 'invalid',
            }

            window.cardNumber = elements.create('cardNumber', {style: cardStyles, classes: elementClasses})
            cardNumber.mount('#card-element')
            cardNumber.on('change', $.proxy(function (event) {
                let displayError = document.getElementById('card-error')
                if (event.error) {
                    displayError.textContent = event.error.message
                } else {
                    displayError.textContent = ''
                }

                if (event.complete) {
                    cardExpiry.focus()
                    $('#card-element').removeClass('has-error')
                    this.cardComplete = true
                }
            }, this))

            // Expiration
            window.cardExpiry = elements.create('cardExpiry', {style: cardStyles, classes: elementClasses})
            cardExpiry.mount('#expiration-element')
            cardExpiry.on('change', $.proxy(function (event) {
                let displayError = document.getElementById('expiration-error')
                if (event.error) {
                    displayError.textContent = event.error.message
                } else {
                    displayError.textContent = ''
                }

                if (event.complete) {
                    $('#expiration-element').removeClass('has-error')
                    cardCvc.focus()
                    this.expirationComplete = true
                }
            }, this))

            // CVC
            window.cardCvc = elements.create('cardCvc', {style: cardStyles, classes: elementClasses})
            cardCvc.mount('#cvc-element')
            cardCvc.on('change', $.proxy(function (event) {
                let displayError = document.getElementById('cvc-error')
                if (event.error) {
                    displayError.textContent = event.error.message
                } else {
                    displayError.textContent = ''
                }

                if (event.complete) {
                    $('#cvc-element').removeClass('has-error')
                    this.cvcComplete = true
                }

            }, this))

            // Wait until stripe is ready
            window.cardNumber.on('ready', $.proxy(function () {
                this.$formSubmitBtn.removeClass('processing').prop('disabled', false)

                // Create Payment Intent
                this._createPaymentIntent()
            }, this))
        }
    },

    initRecaptcha() {
        this.reCaptchaReady = true
        // grecaptcha.ready($.proxy(function () {
        //     this.reCaptchaReady = true
        //     this.executeRecaptcha()
        // }, this))
    },

    executeRecaptcha() {
        grecaptcha.execute('6LeNx7MUAAAAAEauSp8jIi-hnUGinA8DJfY7cJvI', {action: 'making_donation'}).then($.proxy(function (token) {
            $('#g-recaptcha-response').val(token)
            this.reCaptchaToken = token
        }, this))
    },

    checkLocalStorage() {
        if (local.acceptedOct) {
            this.acceptedOct = true
        }
    },

    handleFormSubmit(e) {
        this.formValidation.settings.rules = this.defineFormValidationRules()
        this.formValidation.settings.messages = this.defineFormValidationMessages()
    },

    handleFormKeyPress(e) {
        let keyPressed = e.keyCode || e.which

        if (keyPressed === 13) {
            e.preventDefault()
            return false
        }
    },

    _getCurrentTabCartAmount() {
        let amount = 0

        $.each($('.amount-input'), $.proxy(function (i, item) {
            amount += parseInt($(item).val())
        }))

        return amount
    },

    _useCurrentCart() {
        // Update cart amounts
        destroy()

        $.each(this.$cartItemsContainer.find('.cart-item'), $.proxy(function (i, el) {
            let $element = $(el)
            let data = {
                id: $element.data('id'),
                userId: this.userId,
                price: parseInt($element.find('.amount-input').val()),
                nonprofit: {
                    id: $element.data('id'),
                    name: $element.data('title'),
                    url: $element.data('url'),
                    email: $element.data('email'),
                    taxId: $element.data('taxid'),
                    categoryId: $element.data('category-id'),
                    categoryName: $element.data('category-name'),
                    octPartner: $element.data('oct-partner'),
                    octOrganization: $element.data('oct-organization'),
                    favorited: $element.data('favorited'),
                    contactAboutVolunteering: $element.data('contactAboutVolunteering'),
                }
            }
            add(data)
        }, this))

        this.updateCartTotalAmount()
        this._updateStripePaymentIntent()
    },

    handleFormSubmitManual() {
        let self = this

        let cartRawAmount = this._getCurrentTabCartAmount()

        if (cartRawAmount !== total()) {
            this._useCurrentCart()
        }

        // Clear Errors
        $('.field-input').removeClass('has-error')
        this.$formMessage.html('')

        // Start reCaptcha
        // if (this.reCaptchaReady) {
        //     this.executeRecaptcha()
        // } else {
        //     console.log('reCaptcha is not ready...')
        // }

        // Processing
        this.disableFormActions()

        // Check input validation
        let errors = []
        let inputs = this.$form.find('input')
        inputs.removeClass('has-error')
        $.each(inputs, $.proxy(function (i, input) {
            let type = $(input).data('type')
            let phoneTest = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
            let emailTest = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            // Validate Phone
            if ($(input).val().length > 0 && type === 'phone') {
                let result = $(input).val().match(phoneTest)
                if (result) {

                } else {
                    errors.push($(input).data('invalid-message'))
                    this.$formMessage.append(`<li>${$(input).data('invalid-message')}</li>`)
                    $(input).addClass('has-error')
                }
            }

            // Validate Email
            if ($(input).val().length > 0 && type === 'email') {
                let result = emailTest.test($(input).val())
                if (result) {

                } else {
                    errors.push($(input).data('invalid-message'))
                    this.$formMessage.append(`<li>${$(input).data('invalid-message')}</li>`)
                    $(input).addClass('has-error')
                }
            }

            if ($(input).data('required') && $(input).val() === '') {
                $(input).addClass('has-error')
                errors.push($(input).data('error-message'))
                this.$formMessage.append(`<li>${$(input).data('error-message')}</li>`)
            }
        }, this))

        // Stripe Card Validation
        if (!this.cardComplete) {
            $('#card-error').html(`Your card number is incomplete.`)
            $(`#card-element`).addClass('has-error')
            errors.push('Your card number is incomplete.')
        }
        if (!this.expirationComplete) {
            $('#expiration-error').html(`Your card's expiration date is incomplete.`)
            $(`#expiration-element`).addClass('has-error')
            errors.push('Your card expiration date is incomplete.')
        }
        if (!this.cvcComplete) {
            $('#cvc-error').html(`Your card's security code is incomplete.`)
            $(`#cvc-element`).addClass('has-error')
            errors.push('Your card security code is incomplete.')
        }

        // Scroll to the closest error
        $('.has-error').eq(0).velocity('scroll', {
            duration: 300,
            offset: -200,
            easing: 'easeOutQuart',
        });

        // No Errors, Processes Form
        if (errors.length === 0) {
            // Save Donation Record
            let formValues = FormDataJson.toJson(this.$form)
            api.post('gg/donations/save-donation-revised', formValues)
                .then(function (res) {
                    if (!res.data.success) {
                        // Error
                        let errors = res.data.errors
                        if (errors) {
                            self.$formMessage.addClass('error-message')
                            $.each(errors, function (handle, error) {
                                $(`#${handle}`).addClass('has-error')
                                self.$formMessage.append(`<li>${error}</li>`)

                                if (handle === 'cardError') {
                                    $('#card-element').addClass('has-error')
                                }

                                if (handle === 'invalidAddressError') {
                                    self.invalidAddressModal(formValues)
                                }
                            })

                            $('.has-error').eq(0).velocity('scroll', {
                                duration: 300,
                                offset: -200,
                                easing: 'easeOutQuart',
                            });

                            self.enableFormActions()
                        }

                        if (res.data.recaptcha) {
                            if (!res.data.recaptcha.success) {
                                self.$formMessage.append(`<li class="error-message">reCaptcha Verification Failed. Please refresh the page and try again. If this error continues please try another modern browser.</li>`)

                                self.enableFormActions()
                            }
                        }

                        // Garnish.shake(self.$form)
                    }

                    // Success
                    if (res.data.success) {
                        // Set Donation ID on the form (prevents duplicates)
                        self.$form.find('#donation-id').val(res.data.donation.id);
                        let name = self.$form.find('#firstName').val() + ' ' + self.$form.find('#lastName').val()

                        // Donation has been saved!
                        // Now charge stripe
                        stripe.confirmCardPayment(self.$form.data('foo'), {
                                payment_method: {
                                    card: window.cardNumber,
                                    billing_details: {
                                        name: name,
                                        email: res.data.donation.email,
                                        phone: res.data.donation.phone,
                                        address: {
                                            city: res.data.donation.city,
                                            country: res.data.donation.countryCode, // TODO: verify variable
                                            line1: res.data.donation.address1,
                                            line2: res.data.donation.address2,
                                            postal_code: res.data.donation.zipCode,
                                            state: res.data.donation.stateAbbreviation, // TODO: verify variable
                                        }
                                    },
                                    metadata: {
                                        donationId: res.data.donation.id,
                                        email: res.data.donation.email,
                                    }
                                },
                                //receipt_email: res.data.donation.email, // If enabled, it will send stripe receipt to customer
                            }
                        ).then(function (result) {
                            if (result.error) {
                                if (result.error.payment_intent.status === 'canceled') {
                                    self.$formMessage.addClass('error-message').html(`<li>This payment was canceled. Your cart was likely emptied in another browser tab? Please refresh your page.</li>`)
                                } else {
                                    self.$formMessage.addClass('error-message').html(`<li>${result.error.message}</li>`)
                                }
                                toastr.error('There was error processing donation')
                                self.enableFormActions()
                            } else {
                                self.resetCart()

                                let refNumber = res.data.donation.refNumber
                                let donationId = res.data.donation.id
                                let lineItems = res.data.lineItems

                                if (GG.env === 'production') {
                                    GG.googleEvent('donation', 'status', 'succeeded')

                                    gtag('event', 'purchase', {
                                        "transaction_id": result.id,
                                        "affiliation": "Stripe",
                                        "value": new Intl.NumberFormat('en-US').format(self.amount),
                                        "currency": "USD",
                                        "tax": 0,
                                        "shipping": 0,
                                        "items": self.generateLineItems(lineItems)
                                    })
                                }

                                window.location.href = `${res.data.redirectUrl}?donationId=${donationId}&refNumber=${refNumber}`
                            }
                        })
                    }
                }).catch(function (res) {
                toastr.error('There was error processing form. Please refresh and try again.')
                self.$formMessage.addClass('error-message').html(`<li>There was error processing form. Please refresh and try again.</li>`)
            })

            //     // stripe.createToken(window.cardNumber, stripeTokenData).then($.proxy(function (result) {
            //     //     if (result.error) {
            //     //         this.enableFormActions()
            //     //     } else {
            //     //         // Form Values
            //     //         let formValues = FormDataJson.formToJson(this.$form[0])
            //     //         formValues['stripeToken'] = result.token.id
            //     //
            //     //         // Submit Donation
            //     //         api.post('gg/donations/save-donation', formValues)
            //     //             .then(function (res) {
            //     //                 if (!res.data.success) {
            //     //                     let errors = res.data.errors
            //     //                     if (errors) {
            //     //                         self.$formMessage.addClass('error-message')
            //     //                         $.each(errors, function (handle, error) {
            //     //                             $(`#${handle}`).addClass('has-error')
            //     //                             self.$formMessage.append(`<li>${error}</li>`)
            //     //
            //     //                             if (handle === 'cardError') {
            //     //                                 $('#card-element').addClass('has-error')
            //     //                             }
            //     //                         })
            //     //
            //     //                         $('.has-error').eq(0).velocity('scroll', {
            //     //                             duration: 300,
            //     //                             offset: -200,
            //     //                             easing: 'easeOutQuart',
            //     //                         });
            //     //
            //     //                         self.enableFormActions()
            //     //                     }
            //     //
            //     //                     if (res.data.recaptcha) {
            //     //                         if (!res.data.recaptcha.success) {
            //     //                             self.$formMessage.append(`<li class="error-message">reCaptcha Verification Failed. Please refresh the page and try again. If this error continues please try another modern browser.</li>`)
            //     //
            //     //                             self.enableFormActions()
            //     //                         }
            //     //                     }
            //     //
            //     //                     Garnish.shake(self.$form)
            //     //                 }
            //     //
            //     //                 if (res.data.success) {
            //     //                     destroy()
            //     //                     delete local.acceptedOct
            //     //                     self.removeListener(Garnish.$win, 'beforeunload')
            //     //
            //     //                     let stripeResponse = res.data.stripeResponse
            //     //                     let refNumber = res.data.donation.refNumber
            //     //                     let donationId = res.data.donation.id
            //     //                     let lineItems = res.data.lineItems
            //     //
            //     //
            //     //                     // Trigger only if in production mode
            //     //                     if (GG.env === 'production') {
            //     //                         // Trigger e-comm event
            //     //                         GG.googleEvent('donation', 'status', 'succeeded')
            //     //                         gtag('event', 'purchase', {
            //     //                             "transaction_id": stripeResponse.id,
            //     //                             "affiliation": "Stripe",
            //     //                             "value": new Intl.NumberFormat('en-US').format(stripeResponse.amount),
            //     //                             "currency": "USD",
            //     //                             "tax": 0,
            //     //                             "shipping": 0,
            //     //                             "items": self.generateLineItems(lineItems)
            //     //                         })
            //     //                     }
            //     //
            //     //                     window.location.href = `${res.data.redirectUrl}?donationId=${donationId}&refNumber=${refNumber}`
            //     //                 }
            //     //
            //     //                 // Reset reCaptcha
            //     //                 self.executeRecaptcha()
            //     //             }).catch(function (error) {
            //     //             console.log('error', error)
            //     //         })
            //     //     }
            //     //
            //     // }, this))

        } else {
            this.$formMessage.addClass('error-message')
            toastr.error('There was error processing donation')
            this.enableFormActions()
        }
    },

    invalidAddressModal(formData) {
        let self = this

        $('#address-verification-modal').find('.modal-address').html(`
            ${formData.address.address1}<br>
            ${formData.address.city}, ${$('select#state option:selected').text()} ${formData.address.zipCode}
        `)

        $('#address-verification-modal').show()

        $('#by-pass-address').on('click', function (e) {
            e.preventDefault()
            $('#accept-address-input').val(1);
            $('#address-verification-modal').hide()

            // Force submit form
            self.$formSubmitBtn.click()
        })

        $('#edit-address').on('click', function (e) {
            e.preventDefault()

            // reset reCaptcha
            // self.executeRecaptcha()

            $('#accept-address-input').val(0)
            $('#address1').focus()

            $('#address-verification-modal').hide()
        })
    },

    generateLineItems(lineItems) {
        let data = []

        for (let i = 0; i < lineItems.length; i++) {
            data.push({
                id: lineItems[i].id,
                name: lineItems[i].nonprofitName,
                brand: 'Give!Guide',
                category: lineItems[i].categoryName,
                quantity: 1,
                price: new Intl.NumberFormat('en-US').format(lineItems[i].amount),
            })
        }

        return data
    },

    enableFormActions() {
        this.$formSubmitBtn.html('Pay Now').removeClass('processing')
        this.$formSubmitBtn.prop('disabled', false)
        this.$emptyCartBtn.removeClass('processing')
        this.$emptyCartBtn.prop('disabled', false)

        this.$spinner.addClass('hidden')
    },

    disableFormActions() {
        this.$formSubmitBtn.html('Processing...').addClass('processing')
        this.$formSubmitBtn.prop('disabled', true)
        this.$emptyCartBtn.addClass('processing')
        this.$emptyCartBtn.prop('disabled', true)

        this.$spinner.removeClass('hidden')
    },

    emptyCart(e) {
        e.preventDefault()
        this._cancelStripePaymentIntent()
        destroy()
        GG.Cart.updateCartTotalAmount()
        toastr.info(`Cart emptied`)
        this.$cartWrapper.html('<p class="centered">Cart is empty!</p>')
        this.$emptyCartBtn.remove()
        delete local.cartTotal
        delete local.acceptedOct
        delete local.paymentIntentId
        this.removeListener(Garnish.$win, 'beforeunload')
    },

    resetCart() {
        destroy()
        delete local.acceptedOct
        delete local.paymentIntentId
        this.removeListener(Garnish.$win, 'beforeunload')
    },

    buildListItemsHtml() {
        let self = this

        this.totalCounter = new CountUp('cart-total', total(), {
            startVal: 0,
            duration: 1,
            decimalPlaces: 2,
            useEasing: false,
        })

        this.totalCounter.start()

        api.post('gg/donations/get-list-items-html', {
            items: this.items
        })
            .then(function (res) {
                self.$loader.addClass('off')
                self.$cartItemsContainer.html(res.data.template)

                self.updateCartTotalAmount()
                self.initLineItems()
                self.$cartWrapper.velocity('fadeIn')

                // Init Stripe
                // TODO: disabled temporary
                //self.initStripe()
            })
            .catch(function (error) {
                console.log('error', error)
            })
    },

    updateCartTotalAmount() {
        this.totalCounter.update(total())
        this._amount = total()
        local.cartTotal = this._amount
    },

    initLineItems() {
        let self = this

        $.each(this.$cartItemsContainer.find('.cart-item'), function (i, el) {
            self.lineItems.push(new LineItem(el))
        })

        // Check OCT
        if (!local.acceptedOct) {
            this.initOct()
        }
    },

    removeLineItem(id, octOrganization) {
        for (let i in this.lineItems) {
            if (this.lineItems[i].id === id) {
                this.lineItems.splice(i, 1)
                remove(id) // Remove item from cart
                this.checkIfOctPartners() // check if any Oct Partners left over
                GG.Cart.updateCartTotalAmount()

                if (!this.hasOctPartners) {
                    this.$octMessageContainer.velocity('slideUp')
                }
            }
        }

        // Update items cache
        // this.items = list()
        this.updateCartTotalAmount()
        this._updateStripePaymentIntent()

        // Show OCT Message if OCT Organization item has been removed
        if (octOrganization) {
            this.hasOctOrganizationLineItem = false
        }

        this.handleOctMessage()

        // If no more line items, empty cart
        if (total() === 0) {
            this.$emptyCartBtn.trigger('click')
        }
    },

    checkIfOctPartners() {
        this.hasOctPartners = false

        for (let i in this.lineItems) {
            if (this.lineItems[i].octPartner) {
                this.hasOctPartners = true
            }
        }
    },

    initOct() {
        let self = this

        // Check if any lineItems are OCT Partners
        this.checkIfOctPartners()

        if (this.hasOctPartners) {
            api.post('gg/donations/get-oct-partner-message-html')
                .then(function (res) {
                    self.$octMessageContainer.html(res.data.template)

                    self.checkOct()
                })
                .catch(function (error) {
                    console.log('error', error)
                })
        }
    },

    checkOct() {
        let $acceptOctBtn = this.$octMessageContainer.find('.accept-oct')
        this.addListener($acceptOctBtn, 'click', this.handleAcceptOct)
    },

    updateOctAmount() {
        let octLineItem = this.$cartItemsContainer.find('.oct-item')
        console.log(octLineItem)

        if (octLineItem.length > 0) {
            let octId = octLineItem.data('id')
            let total = 0

            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].id !== octId) {
                    if (this.items[i].nonprofit.octPartner) {
                        let num = this.items[i].price
                        total += num
                    }
                }
            }

            console.log(total)

            // let octItem = get(octId)
            // update(octId, 'price', octItem.price + total)
            //
            // let octLineItemInstance = this.getLineItemById(octId)
            // octLineItemInstance.updateAmountInput()
            //
            // this.updateCartTotalAmount()
            // GG.Cart.updateCartTotalAmount()
        }
    },

    handleAcceptOct() {
        let self = this
        this.$octMessageContainer.velocity('slideUp')
        local.acceptedOct = true
        this.acceptedOct = true
        this.hasOctOrganizationLineItem = true

        let octLineItem = self.$cartItemsContainer.find('.oct-item')

        if (octLineItem.length > 0) {
            let octId = octLineItem.data('id')
            let total = 0

            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].id !== octId) {
                    if (this.items[i].nonprofit.octPartner) {
                        let num = this.items[i].price
                        total += num
                    }
                }
            }

            let octItem = get(octId)
            update(octId, 'price', octItem.price + total)

            let octLineItemInstance = this.getLineItemById(octId)
            octLineItemInstance.updateAmountInput()

            self.updateCartTotalAmount()
            GG.Cart.updateCartTotalAmount()

        } else {
            api.post('gg/donations/get-oct-line-item-html', {
                userId: self.userId
            })
                .then(function (res) {
                    let octTotal = 0

                    self.$cartItemsContainer.append(res.data.template)
                    let octLineItem = new LineItem(self.$cartItemsContainer.find('.oct-item'))
                    self.lineItems.push(octLineItem)

                    for (let i = 0; i < self.items.length; i++) {
                        if (self.items[i].id !== octLineItem.id) {
                            if (self.items[i].nonprofit.octPartner) {
                                let num = parseInt(self.items[i].price)
                                octTotal += num
                            }
                        }
                    }

                    console.log(octTotal)

                    add({
                        id: octLineItem.id,
                        userId: octLineItem.userId,
                        price: octTotal,
                        quantity: 1,
                        nonprofit: {
                            id: octLineItem.id,
                            name: octLineItem.title,
                            url: octLineItem.url,
                            email: octLineItem.email,
                            taxId: octLineItem.taxId,
                            categoryId: octLineItem.categoryId,
                            categoryName: octLineItem.categoryName,
                            octPartner: octLineItem.octPartner,
                            octOrganization: true,
                            favorited: octLineItem.favorited,
                        },
                    })

                    octLineItem.updateAmountInput()
                    self.updateCartTotalAmount()
                    GG.Cart.updateCartTotalAmount()
                    self._updateStripePaymentIntent()
                })
                .catch(function (error) {
                    console.log('error', error)
                })
        }
    },

    handleOctMessage() {
        if (this.acceptedOct) {
            if (!this.hasOctOrganizationLineItem) {
                this.acceptedOct = false
                delete local.acceptedOct

                if (this.$octMessageContainer.is(':empty')) {
                    // if oct message container is empty, go fetch html
                    this.initOct()
                } else {
                    this.$octMessageContainer.velocity('slideDown')
                }
            }
        }
    },

    getLineItemById($id) {
        for (let i = 0; i < this.lineItems.length; i++) {
            if (this.lineItems[i].id === $id) {
                return this.lineItems[i]
            }
        }
    },

    //
    // STRIPE
    //
    _createPaymentIntent() {
        const self = this
        api.post('gg/checkout/init-payment-intent', {
            amount: total(),
            paymentIntentId: local.paymentIntentId,
            items: this.items,
            donor: this.$form.find('#firstName').val() + ' ' + this.$form.find('#lastName').val()
        })
            .then($.proxy(function (res) {
                if (res.data.success) {
                    if (res.data.paymentIntent.status !== 'succeeded') {
                        local.paymentIntentId = res.data.paymentIntent.id
                        this.$form.attr('data-foo', res.data.paymentIntent.client_secret)

                        if (res.data.donationId) {
                            self.$form.find('#donation-id').val(res.data.donationId)
                        }
                    } else {
                        self._paymentAlreadyProcessedMessage(res.data.paymentIntent)
                    }
                }
            }, this))
            .catch(function (error) {
                console.log('Error: ', error)
            })
    },

    _cancelStripePaymentIntent() {
        api.post('gg/checkout/cancel-payment-intent', {
            paymentIntentId: local.paymentIntentId
        })
            .then(function (res) {
                console.log(res)
            })
            .catch(function (error) {
                console.log('error', error)
            })
    },

    _updateStripePaymentIntent() {
        // Update payment intent total amount
        api.post('gg/checkout/update-payment-intent', {
            amount: total(),
            paymentIntentId: local.paymentIntentId,
            items: list(),
        })
            .then($.proxy(function (res) {
                if (res.data.success) {
                    if (res.data.paymentIntent.status !== 'succeeded') {
                        local.paymentIntentId = res.data.paymentIntent.id
                        this.$form.attr('data-foo', res.data.paymentIntent.client_secret)
                    } else {
                        this._paymentAlreadyProcessedMessage(res.data.paymentIntent);
                    }
                }
            }, this)).catch(function (error) {
            console.log('error', error)
        })
    },

    _paymentAlreadyProcessedMessage(payment) {
        let self = this
        api.post('gg/checkout/update-payment-intent-status', {
            paymentIntentId: payment.id,
            status: payment.status,
        })
            .then(function (res) {
                self.resetCart();
                window.location.href = `checkout/already-paid?paymentIntentId=${payment.id}`
            }).catch(function (error) {
            console.log('error', error)
        })
    }
})

// Garnish.$doc.ready(function () {
//     GG.CheckoutIndex = new CheckoutIndex()
// })






















